import { twMerge } from '@/lib/classname/twMerge'
import { SelectSkeleton } from '@/ui/form/inputs/select/SelectSkeleton'
import { ButtonSkeleton } from '@/ui/skeleton/ButtonSkeleton.client'

export function PaginationSkeleton({ className, id, 'data-testid': dataTestId }: UiComponentProps) {
  return (
    <div
      id={id}
      data-testid={dataTestId}
      aria-hidden
      className={twMerge(className, 'flex w-full items-center justify-center gap-1 py-4')}
    >
      <ButtonSkeleton size="lg" isRound />
      <SelectSkeleton withLabel={false} className="w-[6.875rem] min-w-0" />
      <ButtonSkeleton size="lg" isRound />
    </div>
  )
}
